const mercadoPagoGateway = {

    initialize: (idElement) => {
        Mercadopago.setPublishableKey(window.MERCADOPAGO_PUBLIC_KEY);
        Mercadopago.getIdentificationTypes();
    },

    /**
     * @param array data
     * @return mixed
     */
    checkout: (data, _callback) => {

        Mercadopago.createToken(data, function (status, response) {
            if (status == 200 || status == 201) {
                Mercadopago.getPaymentMethod({ 'bin': data.cardNumber }, function (status, responsePayment) {
                    if (status == 200) {
                        let mp_token = response.id;
                        let mp_id = responsePayment[0].id;
                        _callback({mp_token, mp_id});
                    } else {
                        _callback(responsePayment);
                    }
                });
            } else {
                _callback(response);
            }
        });
    },

    /**
     * @param array response
     * @return string 
     */
    showErrorsCallbackInString: (errors) => {

        let msg = 'Internal server error';

        if(errors.cause) {
            msg = '';
            errors.cause.forEach(function(cause) {
                msg += cause.description + ', ';
            });
        }

        return msg;
    }

}

export default mercadoPagoGateway;